import { useQState } from '@/hooks/useQState';
import { ActiveStep } from '../types/activeStep';
import { QUERY_KEY } from '@/const/key-stores';

export const useActiveStep = () => {
  const [activeStep, setActiveStep] = useQState<ActiveStep>(
    QUERY_KEY.medicalConsultationActiveStep,
    'ComprehensiveConsent'
  );

  const setActiveStepFn = (step: ActiveStep) => {
    window.scrollTo(0, 0);
    setActiveStep(step);
  };

  return {
    activeStep,
    setActiveStep: setActiveStepFn
  };
};
